import React, { useState, useEffect } from 'react';
import { SortOrder } from 'react-base-table';
import Table from '@src/components/common/Table';
import resiliencyTableExport from './resiliencyTableExport';
import Empty from './Empty';
import { alphanumericSortUtils } from '@utils/alphanumericSort';
import { getTableColumns } from './utils';
import { StyledTableHeader } from './styled';

const ResiliencyTable = ({ data, interval }) => {
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState<any[]>([]);

  const [columnSortData, setColumnSortData] = useState<{
    order: SortOrder;
    key: string;
  }>({
    order: 'desc',
    key: 'kpisamplesize',
  });

  useEffect(() => {
    const tableColumns = getTableColumns();
    setTableColumns(tableColumns);
  }, [filteredTableData]);

  const columnSort = (data) => {
    const { key, order } = data;
    setColumnSortData({
      order,
      key,
    });
    const sortedData = alphanumericSortUtils(filteredTableData, key, order);
    setFilteredTableData(sortedData);
  };

  useEffect(() => {
    setFilteredTableData(data);
  }, [data]);

  resiliencyTableExport({ data, columns: tableColumns, interval });

  const headerRender = ({ cells, columns: tableColumns }) => {
    return tableColumns.map((item, index) => {
      return (
        <StyledTableHeader key={item.title} title={item.title}>
          {cells[index]}
        </StyledTableHeader>
      );
    });
  };

  return (
    <Table
      data={filteredTableData}
      columns={tableColumns}
      fixed
      headerRenderer={headerRender}
      sortBy={columnSortData}
      onColumnSort={columnSort}
      emptyRenderer={<Empty />}
    />
  );
};

export default ResiliencyTable;
